var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',[_c('NavbarMenu',{attrs:{"slot":"navbar-menu"},slot:"navbar-menu"}),_c('MenuDrawer',{attrs:{"slot":"menu-drawer"},slot:"menu-drawer"}),_vm._t("main",null,{"slot":"main"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }